<template>
    <button :class="['GhostBtn', props.class]">
        <slot></slot>
    </button>
</template>

<script lang="ts" setup>
import { HTMLAttributes, PropType } from 'vue';

const props = defineProps({
    class: {
        type: String as PropType<HTMLAttributes['class']>,
        default: ''
    }
})
</script>

<style scoped lang="scss">
.GhostBtn {
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    border-radius: 0.25rem;
    background: transparent;
    border: none;
    height: 2rem;
    cursor: pointer;

    @include PaddingAreas(0, 0.25);

    &:hover, &:focus {
        background: $Blue-100;
    }

    &:focus {
        outline: 1px solid $Blue-600;
    }
}
</style>